import React from "react";

export default function PublicInfoSection({
  t,
  ChangeImage,
  openIsChange,
  closeIsChange,
  sendData,
  isChange,
  parsedUserProfile,
  firstLanguage,
  setFirstLanguage,
  languages,
  firstLanguageSkillLevel,
  setFirstLanguageSkillLevel,
  alsoSpeak,
  setAlsoSpeak,
  birthYear,
  handleYearChange,
  years,
  school,
  setSchool,
  cityCountry,
  setCityCountry,
  transform_languages,
  transform_skillLevel,
}) {
  return (
    <div id="section1" className="w-full flex flex-col p-2 md:pb-12 pb-2">
      <div className="relative w-full text-center">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300"></div>
        </div>
        <span className="relative bg-[var(--bg)] px-3 text-lg font-bold text-[var(--brand)] uppercase tracking-wider">
          {t("user_home.public_info")}
        </span>
      </div>

      <button className="flex justify-end">
        <img
          src={ChangeImage}
          alt="changeProfile"
          className="md:w-[40px] md:h-[40px]"
          onClick={openIsChange}
        />
      </button>

      <div className="flex gap-5 md:gap-10 flex-col md:flex-row">
        {/* Left side of the section of MY PUBLIC INFO */}
        <div className="w-full md:w-1/2 flex flex-col gap-4">
          <div className="flex items-start md:items-center flex-col md:flex-row gap-2">
            <p className="text-base md:text-lg font-medium text-[var(--brand)] md:min-w-[200px]">
              {t("user_home.1st_lang")}:
            </p>
            {isChange === false ? (
              <p className="text-base md:text-lg font-normal text-black">
                {t(transform_languages(parsedUserProfile?.first_language))}
              </p>
            ) : (
              <select
                type="select"
                className="border border-[var(--brand)] px-2 py-1 bg-[var(--bg)] text-base w-full md:w-auto"
                value={firstLanguage || ""}
                onChange={(e) => setFirstLanguage(e.target.value)}
              >
                <option value="">{t("user_home.select")}</option>
                {languages.map((language) => (
                  <option key={language.value} value={language.value}>
                    {t(language.label)}
                  </option>
                ))}
              </select>
            )}
          </div>
          <div className="flex items-start md:items-center flex-col md:flex-row gap-2">
            <p className="text-base md:text-lg font-medium text-[var(--brand)] md:min-w-[200px]">
              {t("user_home.1st_lang_skill")}:
            </p>
            {isChange === false ? (
              <p className="text-base md:text-lg font-normal text-black">
                {t(
                  transform_skillLevel(
                    parsedUserProfile?.first_language_skill_level
                  )
                )}
              </p>
            ) : (
              <select
                type="select"
                className="border border-[var(--brand)] px-2 py-1 bg-[var(--bg)] text-base w-full md:w-auto"
                value={firstLanguageSkillLevel || ""}
                onChange={(e) => setFirstLanguageSkillLevel(e.target.value)}
              >
                <option value={""}>{t("user_home.select")}</option>
                <option value={"1"}>{t("generic.skill_1")}</option>
                <option value={"2"}>{t("generic.skill_2")}</option>
                <option value={"3"}>{t("generic.skill_3")}</option>
                <option value={"4"}>{t("generic.skill_4")}</option>
                <option value={"5"}>{t("generic.skill_5")}</option>
              </select>
            )}
          </div>
          <div className="flex items-start md:items-center flex-col md:flex-row gap-2">
            <p className="text-base md:text-lg font-medium text-[var(--brand)] md:min-w-[200px]">
              {t("user_home.also_speak")}:
            </p>
            {isChange === false ? (
              <p className="text-base md:text-lg font-normal text-black">
                {parsedUserProfile?.also_speak}
              </p>
            ) : (
              <input
                type="text"
                className="border border-[var(--brand)] px-2 py-1 bg-[var(--bg)] text-base w-full md:w-auto"
                value={alsoSpeak || ""}
                onChange={(e) => setAlsoSpeak(e.target.value)}
              />
            )}
          </div>
        </div>

        {/* Right side of the section of MY PUBLIC INFO */}
        <div className="w-full md:w-1/2 flex flex-col gap-4">
          <div className="flex items-start md:items-center flex-col md:flex-row gap-2">
            <p className="text-base md:text-lg font-medium text-[var(--brand)] md:min-w-[200px]">
              {isChange ? t("user_home.birthday") : t("user_home.age")}
            </p>
            {isChange ? (
              <div className="w-full md:w-auto">
                <label
                  htmlFor="birthYear"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Year of Birth:
                </label>
                <select
                  id="birthYear"
                  value={birthYear}
                  onChange={handleYearChange}
                  className="border border-[var(--brand)] px-2 py-1 bg-[var(--bg)] text-base w-full md:w-auto"
                >
                  <option value="" disabled>
                    Select a year
                  </option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              <p className="text-base md:text-lg font-normal text-black">
                {parsedUserProfile?.age}
              </p>
            )}
          </div>
          <div className="flex items-start md:items-center flex-col md:flex-row gap-2">
            <p className="text-base md:text-lg font-medium text-[var(--brand)] md:min-w-[200px]">
              {t("user_home.school")}:
            </p>
            {isChange === false ? (
              <p className="text-base md:text-lg font-normal text-black">
                {parsedUserProfile?.school}
              </p>
            ) : (
              <input
                type="text"
                className="border border-[var(--brand)] px-2 py-1 bg-[var(--bg)] text-base w-full md:w-auto"
                value={school || ""}
                onChange={(e) => setSchool(e.target.value)}
              />
            )}
          </div>
          <div className="flex items-start md:items-center flex-col md:flex-row gap-2">
            <p className="text-base md:text-lg font-medium text-[var(--brand)] md:min-w-[200px]">
              {t("user_home.city_country")}:
            </p>
            {isChange === false ? (
              <p className="text-base md:text-lg font-normal text-black">
                {parsedUserProfile?.city_country}
              </p>
            ) : (
              <input
                type="text"
                className="border border-[var(--brand)] px-2 py-1 bg-[var(--bg)] text-base w-full md:w-auto"
                value={cityCountry || ""}
                onChange={(e) => setCityCountry(e.target.value)}
              />
            )}
          </div>
        </div>
      </div>
      {isChange && (
        <div className="flex justify-end gap-4">
          <button
            className="bg-[var(--brand)] rounded-[5px] w-[70px] h-[30px] xl:w-[100px] xl:h-[40px] text-white"
            onClick={closeIsChange}
          >
            {t("generic.cancel")}
          </button>
          <button
            className="bg-[var(--brand)] rounded-[5px] w-[70px] h-[30px] xl:w-[100px] xl:h-[40px] text-white"
            onClick={sendData}
          >
            {t("generic.save")}
          </button>
        </div>
      )}
    </div>
  );
}
